import { OperandOption, IProblem, IProblemGenerator } from "./sharedTypes";

const DEFAULT_MAX_RESULT = 20;

export type AdditionOptions = {
    maxResult?: number;
    operand1?: OperandOption;
    operand2?: OperandOption;
    progression?: boolean;
    progressionRate?: number;
}
export default class AdditionProblemGenerator implements IProblemGenerator {
    private options?: AdditionOptions;
    private currentStreak: number;

    constructor(options?: AdditionOptions) {
        this.options = options;
        this.currentStreak = 0;

        if (options?.progression === true) {
            console.log(`Using progression for addition`)
            if (options?.maxResult === undefined)
                throw new Error(`Addition Progression works on maxResult, a starting maxResult must be specified`);
        }
    }

    getNext() : IProblem {
        const op1Range = Math.min(this.options?.maxResult ?? 100, this.options?.operand1?.max?? 100) - (this.options?.operand1?.min ?? 0);
        const operand1 = Math.round(Math.random() * (op1Range)) + (this.options?.operand1?.min ?? 0)

        let operand2 = 0;
        let op2Max = Math.min((this.options?.maxResult ?? 100) - operand1, this.options?.operand2?.max ?? 100);
        let op2Min = this.options?.operand2?.min ?? 0;

        if (op2Max < op2Min)
            op2Max = op2Min;

        operand2 = Math.round(Math.random() * (op2Max - op2Min)) + op2Min;
        
        return {
            generator: "Addition",
            display: `${operand1} + ${operand2}`,
            correctAnswer: operand1 + operand2,
            userAnswer: undefined,
        }
    }
    reportResult(wasCorrect: boolean, userAnswer: number) {
        if (this.options?.progression === true) {

            if (wasCorrect) {
                this.currentStreak += 1;
            } else {
                this.currentStreak = 0;
            }

            if (this.currentStreak >= (this.options?.progressionRate ?? 10)) {
                
                
                if (this.options?.maxResult)
                {
                    this.options.maxResult += 1;
                    console.log(`Setting op1 min to ${(this.options?.operand1?.min ?? 0) + 1}`)
                    if (this.options.operand1)
                        this.options.operand1 = { max: Math.round(this.options.maxResult*0.5) , min: Math.round(this.options.maxResult*0.25)};
                    if (this.options.operand2)                    
                        this.options.operand2 = { max: Math.round(this.options.maxResult*0.5), min: Math.round(this.options.maxResult*0.1)};
                }
                console.log(`Increasing addition difficulty`, this.options)
                this.currentStreak = 0;
            }
        }
    }
}